import { FloatingTextComponent } from '../floatingtextcomponent';
import { UIComponentHandler, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { MsisdnFloatingTextViewImpl } from './msisdnfloatingtextview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { MsisdnFloatingTextCSSStyleImpl } from './msisdnfloatingtextcss';
import { BaseContext } from '../../../../utils/basecontext';


export class MsisdnFloatingTextComponent extends FloatingTextComponent 
{
    
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MsisdnFloatingTextViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MsisdnFloatingTextCSSStyleImpl(applicationContext);
    }
   

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent.tsx